import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
    background: ${(p) => p.color || "#2e186a"};
    color: ${(p) => (p.color ? "#2E186A" : "#fff")};
    font-size: 1rem;
    font-weight: 700;
    width: 100%;
    border: 1px solid #edf3f5;
    border-radius: 4px;
    padding: 13px 0;
    cursor: pointer;
    margin-top: 0.625rem;
    max-width: 180px;

    background-color: ${(p) => p.color || "#2e186a"};
    box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

    transition:
        transform 0.12s ease,
        box-shadow 0.12s ease,
        background-color 0.2s ease;

    &:hover {
        background-color: rgb(255, 130, 92);
        border: 1px solid rgb(255, 130, 92);
        color: #fff;
    }

    &:active {
        transform: scale(0.96);
        box-shadow: 0 6px 14px rgb(23 31 114 / 25%);
    }

    // animation click
    position: relative;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(255, 255, 255, 0.3);
        opacity: 0;
        transition: opacity 0.3s;
    }

    &:active::after {
        opacity: 1;
        transition: none;
    }

    &:focus-visible {
        outline: 2px solid rgb(255, 130, 92);
        outline-offset: 2px;
  }
`;
